var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'default__container',
    { 'default__container--with-banner': _vm.isReportPreview }
  ]},[(_vm.isReportPreview)?_c('FreeToolBanner'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }